import { render, staticRenderFns } from "./UsersListSidebar.vue?vue&type=template&id=084f6c94&scoped=true"
import script from "./UsersListSidebar.vue?vue&type=script&lang=js"
export * from "./UsersListSidebar.vue?vue&type=script&lang=js"
import style0 from "./UsersListSidebar.vue?vue&type=style&index=0&id=084f6c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f6c94",
  null
  
)

export default component.exports